export default {"src":"/_next/static/media/centralized-management.fdda69e4.svg","height":888,"width":888,"blurWidth":0,"blurHeight":0};